import { CONTENT_TYPE, DEFAULT_TENANT_ID } from 'common/constants';
import localStorageWrapper from 'common/loginUtils/local-storage-wrapper';
import storageWrapper from 'common/loginUtils/storage-wrapper';

import apiWrapper from '../../../../common/api/api-wrapper';
import { IAPIErrorContent } from '../../../../common/api/type-def';

import {
	IAddUserResponse,
	IAddUserErrorResponse,
	IAddUserMailData,
	IEditUserResponse,
	IUser,
	IAllUsersApiResponse,
	IUserStatus,
} from './type-def.js';

const { REACT_APP_USER_MANAGEMENT_SERVICE_URL, REACT_APP_USER_SERVICE_URL } =
	process.env;

export const createUser = async (data: any) => {
	const resp = await apiWrapper.post<IAddUserResponse | IAddUserErrorResponse>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/user`,
		data,
	);
	return resp;
};

export const getAllGroups = async () => {
	const resp = await apiWrapper.get<any[]>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/groups`,
	);
	return resp;
};

export const editUser = async (data: any) => {
	const resp = await apiWrapper.put<IEditUserResponse>(
		`${REACT_APP_USER_SERVICE_URL}/${data.userId}`,
		data,
	);
	return resp;
};

export const getUserInfo = async () => {
	const tenantId =
		localStorageWrapper.getStorageItem('tenantId') || DEFAULT_TENANT_ID;

	const config: any = {
		headers: {
			'id-token': storageWrapper.getStorageItem('id-token'),
			'X-TENANT-ID': tenantId,
		},
	};
	const resp = await apiWrapper.get<IUser, IAPIErrorContent>(
		`${REACT_APP_USER_SERVICE_URL}/userInfo`,
		{},
		CONTENT_TYPE.JSON,
		config.headers,
	);
	return resp;
};

export const getUserByUserId = async (data: string) => {
	const resp = await apiWrapper.get<IUser, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/user/${data}`,
	);
	return resp;
};

export const getAllUsersList = async (data: any) => {
	let sortKey = '';
	if (data.sortKey) {
		sortKey = data?.sortKey === 'firstName' ? 'firstName' : data?.sortKey;
	}
	const sortDirection = data?.sortDirection ? data?.sortDirection : '';
	const sortk = sortKey !== '' ? `${sortKey}` : '';
	const sortDir = sortDirection !== '' ? `${sortDirection}` : '';
	const resp = await apiWrapper.get<IAllUsersApiResponse, IAPIErrorContent>(
		`${REACT_APP_USER_SERVICE_URL}/users?pageNumber=${data?.pageNumber}&pageSize=${data?.pageSize}&sortBy=${sortk}&sortOrderBy=${sortDir}`,
	);
	return resp;
};

export const getMailIdList = async () => {
	const baseUrl = REACT_APP_USER_MANAGEMENT_SERVICE_URL;
	const resp = await apiWrapper.get<IAddUserMailData[], IAPIErrorContent>(
		`${baseUrl}/okta/users`,
	);
	return resp;
};

export const updateTermsAndPolicyStatus = async (id: string, data: any) => {
	const baseUrl = REACT_APP_USER_SERVICE_URL;
	const resp = await apiWrapper.put<IUserStatus, IAPIErrorContent>(
		`${baseUrl}/${id}`,
		data,
	);
	return resp;
};
